/**
 * TPS-CUSTOM — Scripts propios de Tu Punto Shop (se carga con defer).
 * Ajustes en el editor: Configuración del tema → "TPS · Personalizaciones".
 * Registro: docs/PERSONALIZACIONES.md
 */
(function () {
  var settings = window.TPS_SETTINGS || {};

  /* ------------------------------------------------------------------
     1. Texto del botón "Comprar ahora" (por defecto "Comprar💕").
     Shopify dibuja ese botón por su cuenta (a veces después de cargar
     la página), así que se vigila el DOM y se cambia cada vez que aparece.
     ------------------------------------------------------------------ */
  var buyNowText = (settings.buyNowText || '').trim();
  var BUY_NOW_SELECTOR = '.shopify-payment-button__button--unbranded';

  function renameBuyNow() {
    document.querySelectorAll(BUY_NOW_SELECTOR).forEach(function (button) {
      if (button.textContent.trim() !== buyNowText) button.textContent = buyNowText;
    });
  }

  if (buyNowText) {
    renameBuyNow();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        renameBuyNow();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------
     2. Carruseles de productos/colecciones que avanzan solos.
     - Solo en computador (≥ 750 px) y si el cliente no pidió reducir
       animaciones. En celular la rotación automática confunde (Baymard).
     - Se pausa al pasar el mouse, si la pestaña está oculta o si el
       carrusel no está en pantalla. Se detiene del todo si el cliente
       lo usa (clic, toque o teclado).
     - Al llegar al final vuelve al inicio.
     ------------------------------------------------------------------ */
  if (!settings.carouselAutoplay) return;

  var desktop = window.matchMedia('(min-width: 750px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var intervalMs = Math.max(4, Number(settings.carouselSpeed) || 6) * 1000;

  function setupCarousel(slideshow) {
    if (slideshow.__tpsAutoplay) return;
    slideshow.__tpsAutoplay = true;

    var visible = false;
    var stopped = false;

    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
    }, { threshold: 0.4 }).observe(slideshow);

    ['pointerdown', 'keydown', 'touchstart'].forEach(function (type) {
      slideshow.addEventListener(type, function () { stopped = true; }, { passive: true, once: true });
    });

    setInterval(function () {
      if (stopped || !visible || document.hidden) return;
      if (!desktop.matches || reducedMotion.matches) return;
      if (slideshow.matches(':hover') || slideshow.matches(':focus-within')) return;
      if (typeof slideshow.select !== 'function') return;

      if (slideshow.atEnd) {
        slideshow.select(0);
      } else {
        slideshow.next();
      }
    }, intervalMs);
  }

  function init() {
    document.querySelectorAll('slideshow-component[data-tps-autoplay]').forEach(setupCarousel);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('slideshow-component').then(init);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
  // Secciones que el editor o el tema vuelven a dibujar.
  document.addEventListener('shopify:section:load', init);
})();
